export default "__VITE_ASSET__qOhue2In__"